module.exports = __webpack_public_path__ + "static/media/icon-pdf.789fb49c.svg";